import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import UserDetails from "./components/ui/UserDetails";
import VideoRecorder from "./components/ui/VideoRecorder";
import VerifyPage from "./components/ui/VerifyPage";
import VerificationSuccess from "./components/ui/VerificationSucess";
import ProtectedRoute from "./components/ui/ProtectedRoute";
import { NavigationProvider } from "./components/contexts/NavigationContext";
import Landing from "./components/ui/Landing";

// const App = () => {
//   return (
//     <NavigationProvider>
//       <Router>
//         <Routes>
//           <Route path="/" element={<Landing />} />
//           <Route path="/consent-form" element={<UserDetails />} />
//           <Route path="/verify" element={<VerifyPage />} />
//           <Route
//             path="/record"
//             element={
//               <ProtectedRoute>
//                 <VideoRecorder />
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/verification-success"
//             element={<VerificationSuccess />}
//           />
//         </Routes>
//       </Router>
//     </NavigationProvider>
//   );
// };
const App = () => {
  return (
    <NavigationProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route
            path="/consent-form"
            element={
              <ProtectedRoute>
                <UserDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/record"
            element={
              <ProtectedRoute>
                <VideoRecorder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/verification-success"
            element={
              <ProtectedRoute>
                <VerificationSuccess />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </NavigationProvider>
  );
};
export default App;
